/**
 * /frontend/src/features/analytics/hooks/usePeakAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getPeakDayComparison, getPeakHeatmap, getPeakTopHours } from '../api/peakAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads peak analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const usePeakAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, startDate, endDate, weeks, date, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [heatmap, topHours, dayComparison] = await Promise.all([
      getPeakHeatmap(request, storeToken, storeUuid, startDate, endDate),
      getPeakTopHours(request, storeToken, storeUuid, weeks),
      getPeakDayComparison(request, storeToken, storeUuid, date),
    ]);
    return { heatmap, topHours, dayComparison };
  }, [date, endDate, request, startDate, storeToken, storeUuid, weeks]);

  const resource = useAnalyticsResource(enabled, fetcher, 'usePeakAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default usePeakAnalytics;
